module.exports = __webpack_public_path__ + "img/UWUAngel.0dc3227c.png";